import { useEffect } from 'react';
import { useLocation } from '@reach/router';
// material
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
// components
import Scrollbar from '../ManagementPanel/components/Scrollbar';
//
import { MHidden } from '../ManagementPanel/components/@material-extend';
// Hooks
import useCollapseDrawer from '../ManagementPanel/hooks/useCollapseDrawer';

import { useSelector } from 'react-redux';
import { getProgressSteps } from '../../store/policystreamStore';

// types and classes
import type { $TSFixMe } from '@calefy-inc/utilityTypes';

import { PolicyStreamProgressBar } from './components';
import { PolicyStreamNeedHelp } from './components/PolicyStreamNeedHelp';
import { NeedHelpCard as HamburgerCard } from './components/PolicyStreamNeedHelp';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 340;
const COLLAPSE_WIDTH = 102;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.complex,
    }),
  },
}));

interface PolicyStreamHamburgerMenuProps {
  isOpenSidebar: boolean;
  onCloseSidebar: $TSFixMe; // function
}
export default function PolicyStreamHamburgerMenu({
  isOpenSidebar,
  onCloseSidebar,
}: PolicyStreamHamburgerMenuProps) {
  const { pathname } = useLocation();
  const steps = useSelector(getProgressSteps);

  const {
    // @ts-expect-error
    isCollapse,
    collapseClick,
  } = useCollapseDrawer();

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: '100%',
        '& .simplebar-content': {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          px: 2.5,
          pt: 3,
          pb: 2,
          ...(isCollapse && {
            alignItems: 'center',
          }),
        }}
      >
        <CloseButtonContainer>
          <Button
            onClick={() => onCloseSidebar()}
          >
            <CloseIcon />
          </Button>
        </CloseButtonContainer>
        {steps.some((step) => step.status !== 'NOT_VISITED') && (
          <HamburgerCard>
            <p>Your progress</p>
            <PolicyStreamProgressBar />
          </HamburgerCard>
        )}
        <PolicyStreamNeedHelp isInHamburgerMenu={true}/>

      </Stack>
    </Scrollbar>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse ? COLLAPSE_WIDTH : DRAWER_WIDTH,
        },
        ...(collapseClick && {
          position: 'absolute',
          right: 0,
        }),
      }}
    >
      <MHidden width='lgUp'>
        <Drawer
          anchor="right"
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>
    </RootStyle>
  );
}

const CloseButtonContainer = styled('div')(() => ({
  textAlign: 'right',
}));